export default function useMoneyFormater() {
  function formatMoneyWithCurrency(
    number: number,
    currency: "RUB" | "USD" = "RUB",
    minFractionDigitals = 0
  ) {
    const defaultFormater = new Intl.NumberFormat("ru-RU", {
      style: "currency",
      currency,
      minimumFractionDigits: minFractionDigitals,
    });

    return defaultFormater.format(number);
  }

  function moneyFormater(number: number, minFractionDigitals = 0) {
    const defaultFormater = new Intl.NumberFormat("ru-RU", {
      style: "currency",
      currency: "RUB",
      minimumFractionDigits: minFractionDigitals,
    });

    return defaultFormater.format(number);
  }

  return { formatMoneyWithCurrency, moneyFormater };
}
